<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex   justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded text-center">
              <span class="text-xl  "> Markt Übersicht</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full flex flex-col gap-4">

              <div class=" flex flex-col ">
                <div class="flex mt-2  w-full">
                  <span class="bg-primary w-1/4 p-2 rounded">Name:</span>
                  <input class="border p-2 rounded w-3/4" data-ui="name" v-model="name">
                </div>
                <div class="flex mt-2  w-full">
                  <span class="bg-primary w-1/4 p-2 rounded">Beschreibung / Ort:</span>
                  <input class="border p-2 rounded w-3/4" data-ui="description" v-model="description">
                </div>
                <div class="flex mt-2  w-full">
                  <span class="bg-primary w-1/4 p-2 rounded">SAP Marktname:</span>
                  <input class="border p-2 rounded w-3/4" data-ui="description" v-model="sapMarketName">
                </div>

                <div class="flex mt-2  w-full">
                  <span class="bg-primary w-1/4 p-2 rounded">Status:</span>
                  <select class="border p-2 rounded w-3/4" data-ui="isActive" v-model="isActive">
                    <option data-ui="Sichtbar" :value="true">Sichtbar</option>
                    <option data-ui="Nicht Sichtbar" :value="false">Nicht Sichtbar</option>
                  </select>
                </div>
              </div>

              <div class=" flex flex-col ">
                <div class="flex mt-2  w-full" v-for="marketCustomField in marketCustomFields"
                     :key="marketCustomField.idCustomField">
                  <span class="bg-primary w-1/4 p-2 rounded">{{ marketCustomField.label }}</span>
                  <input class="border p-2 rounded w-3/4" v-model="marketCustomField.fieldValue"
                         :data-ui="marketCustomField.label">
                </div>
                <button @click="editMarket"
                        class=" mr-1 w-full rounded mt-2 p-3 bg-trader-green hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out"
                        data-ui="save-edit-market">
                  Speichern
                </button>
                <button @click="deleteTrue"
                        class=" mr-1 w-full rounded mt-2 p-3 bg-trader-red hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out"
                        data-ui="delete-market">
                  Löschen
                </button>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <Sidebar/>
  </div>
</template>


<script>

import Sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";
import {mutation, query} from "@/graphql";

export default {
  components: {CGoBack, Sidebar},
  data() {
    return {
      name: '',
      description: '',
      isActive: '',
      marketId: 0,
      market: null,
      sapMarketName: '',
      delete: false,
      marketCustomFields: [],
      idCustomField: 0,
      fieldValue: '',
      label: '',
      fieldName: '',
      accordionIndex: 0
    }
  },
  methods: {
    deleteTrue() {
      eventBus.openConfirm({
        title: "Markt",
        message: "Möchten Sie diesen Markt wirklich löschen?",
        onAccept: () => {
          this.deleteMarket();
        }
      });
    },
    goBack() {
      router.push("/administration")
    },
    deleteMarket() {
      this.delete = true;
      this.editMarket()
    },
    async editMarket() {
      let customFieldValues = [];
      this.marketCustomFields.forEach(function (marketCustomField) {
        customFieldValues.push({
          idMarketCustomField: marketCustomField.idCustomField,
          fieldValue: marketCustomField.fieldValue
        })
      })
      const marketData = {
        marketId: this.marketId,
        name: this.name,
        description: this.description,
        isActive: this.isActive,
        delete: this.delete,
        customFieldValues: customFieldValues,
        sapMarketName: this.sapMarketName
      };

      const [data, err] = await mutation.editMarket(marketData);
      if (this.delete) {
        if (data.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Markt gelöscht",
            message: "Der Markt wurde gelöscht.",
          });
          router.push(`/administration/${this.accordionIndex}`)
        }
        if (data.code === "MARKET-USED") {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Markt nicht gelöscht",
            message: "Der Markt konnte nicht gelöscht werden. Da er noch in Verwendung ist.",
          });
        }
      } else {
        if (data.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Markt gespeichert",
            message: "Der Markt wurde gespeichert.",
          });
        }
      }

    },
    async getMarket() {

      const [data, err] = await query.getMarket(this.marketId);
      try {
        this.market = data;
        this.name = this.market.name
        this.description = this.market.description
        this.isActive = this.market.isActive
        this.sapMarketName = this.market.sapMarketName
      } catch (error) {
        console.error(error);
      }
    },
    async getMarketCustomField() {
      const query = gql`
        query getMarketCustomFieldValues($marketId: Int!) {
          getMarketCustomFieldValues(marketId: $marketId)  {
            idCustomField
            idMarket
            fieldValue
            fieldName
            label
          }
        }
      `;
      try {
        const variables = {marketId: this.marketId};
        const {data} = await apolloClient.query({query, variables});
        this.marketCustomFields = data.getMarketCustomFieldValues;

      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {
    '$route.params.marketId': function (newId, oldId) {
      this.marketId = newId;
      this.getMarket();
      this.getMarketCustomField();
    },
  },
  created() {
    if (this.$route.params.marketId != null && typeof this.$route.params.marketId != 'undefined' && this.$route.params.marketId != '') {
      this.marketId = this.$route.params.marketId;
      this.getMarket();
      this.getMarketCustomField();
    }
    this.accordionIndex = this.$route.params.accordionIndex
  }
}
</script>
